import comp from "./DeliverySettingsV2";
export default comp;
